{
  "title": "Mage Armor",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level abjuration",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a piece of cured leather)",
  "duration": "8 hours",
  "description": [
    "You touch a willing creature who isn’t wearing armor, and a protective magical force surrounds it until the spell ends. The target’s base AC becomes 13 + its Dexterity modifier. The spell ends if the target dons armor or if you dismiss the spell as an action."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
